// @flow
import { trackEvent } from 'utils/analytics';

type SetGMapsErrorAction = {
  type: 'SET_GMAPS_ERROR'
};

export type Action = SetGMapsErrorAction;

export const setGMapsError = (error: string): SetGMapsErrorAction => {
  trackEvent('Google Maps API Error', { error });
  return { type: 'SET_GMAPS_ERROR' };
};
